<div class="app-admin-wrap" [dir]="layoutConf?.dir">
  <!-- Header for top navigation layout -->
  <!-- ONLY REQUIRED FOR **TOP** NAVIGATION LAYOUT -->
  @if (showHeader && layoutConf.navigationPos === 'top') {
  <app-header-top [notificPanel]="notificationPanel"> </app-header-top>
  }

  <!-- Main Container -->
  <mat-sidenav-container
    [dir]="layoutConf.dir"
    class="app-admin-container app-side-nav-container mat-drawer-transition sidebar-{{
      layoutConf?.sidebarColor
    }} topbar-{{ layoutConf?.topbarColor }} footer-{{ layoutConf?.footerColor }}"
    [ngClass]="adminContainerClasses"
  >
    <mat-sidenav-content>
      <!-- SIDEBAR -->
      <!-- ONLY REQUIRED FOR **SIDE** NAVIGATION LAYOUT -->
      @if (showSidebar && layoutConf.navigationPos === 'side') {
      <app-sidebar-side
        (mouseenter)="sidebarMouseenter($event)"
        (mouseleave)="sidebarMouseleave($event)"
      ></app-sidebar-side>
      }

      <!-- Top navigation layout (navigation for mobile screen) -->
      <!-- ONLY REQUIRED FOR **TOP** NAVIGATION MOBILE LAYOUT -->
      @if (showSidebar && layoutConf.navigationPos === 'top' && layoutConf.isMobile) {
      <app-sidebar-top></app-sidebar-top>
      }

      <!-- App content -->
      <div
        class="main-content-wrap"
        id="main-content-wrap"
        [perfectScrollbar]=""
        [disabled]="layoutConf.topbarFixed || !layoutConf.perfectScrollbar"
      >
        <!-- Header for side navigation layout -->
        <!-- ONLY REQUIRED FOR **SIDE** NAVIGATION LAYOUT -->
        @if (showHeader && layoutConf.navigationPos === 'side') {
        <app-header-side [notificPanel]="notificationPanel"> </app-header-side>
        }

        <div
          class="rightside-content-hold"
          id="rightside-content-hold"
          [perfectScrollbar]="scrollConfig"
          [disabled]="!layoutConf.topbarFixed || !layoutConf.perfectScrollbar"
        >
          <!-- View Loader -->
          @if (isModuleLoading) {
          <div
            class="view-loader"
            style="position: fixed"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            <div class="spinner">
              <div class="double-bounce1 mat-bg-accent"></div>
              <div class="double-bounce2 mat-bg-primary"></div>
            </div>
          </div>
          }

          <!-- Breadcrumb -->
          <!-- <app-breadcrumb></app-breadcrumb> -->

          <!-- View outlet -->
          <div class="container-dynamic" [ngClass]="containerClasses">
            <ng-content></ng-content>
          </div>
          @if (!layoutConf.footerFixed) {
          <span class="m-auto"></span>
          }
          <!-- <app-footer *ngIf="!layoutConf.footerFixed" style="margin: 0 -.33rem -.33rem"></app-footer> -->
        </div>
        @if (layoutConf.footerFixed) {
        <span class="m-auto"></span>
        }
        <!-- <app-footer *ngIf="layoutConf.footerFixed"></app-footer> -->
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
